module.exports = require('./helpers/bundle-url').getBundleURL('scYWC') + "logo-dark.eefe0b7f.svg";